import { Box, Grid, Typography, useMediaQuery, IconButton } from "@mui/material";
import logo from "../assets/logo/radix.png";
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';


const FooterComponent = () => {
    const isSmallScreen = useMediaQuery('(max-width:600px)');
    const currentYear = new Date().getFullYear();

    return (
        <Box sx={{ bgcolor: '#f2f2f2', color: '#333', pt: 8, pb: 4, px: isSmallScreen ? 2 : 10, borderTop: '4px solid #08244d' }}>
            <Grid container spacing={6}>

                {/* Column 1: Brand */}
                <Grid item xs={12} md={4}>
                    <Box component="img" src={logo} alt="Radix Logo" sx={{ height: 50, mb: 3 }} />
                </Grid>

                {/* Column 2: Address */}
                <Grid item xs={12} md={4}>
                    <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                        <LocationOnIcon sx={{ color: '#08244d', mt: 0.5 }} />
                        <Typography variant="body2" sx={{ lineHeight: 1.6, color: '#546e7a', textAlign: 'start' }}>
                            <strong>Cebu, Philippines Office:</strong><br />
                            5 Ma. Cristina St.<br />
                            Brgy. Capitol Site<br />
                            Cebu City 6000 Philippines
                        </Typography>
                    </Box>
                </Grid>

                {/* Column 3: Contact */}
                <Grid item xs={12} md={4}>
                    <Box sx={{ mb: 4 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                            <MailIcon sx={{ color: '#08244d', fontSize: 20 }} />
                            <Typography variant="body2" sx={{ color: '#546e7a' }}>radix_info@radigroup.co</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <PhoneIcon sx={{ color: '#08244d', fontSize: 20 }} />
                            <Typography variant="body2" sx={{ color: '#546e7a' }}>Telephone: +63 (32) 384-9309</Typography>
                        </Box>
                    </Box>
                </Grid>

            </Grid>

            {/* Bottom Bar */}
            <Box sx={{ borderTop: '1px solid #eee', mt: 8, pt: 4, textAlign: 'center' }}>
                <Typography variant="caption" sx={{ color: '#90a4ae' }}>
                    &copy; {currentYear} Radix Group Inc. All Rights Reserved. Powered by Radix.
                </Typography>
            </Box>
        </Box>
    );
}

export default FooterComponent;